import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'

// Calendar Actions
export const trackMeetingsCalendarNextMonth = () => trackKey(keys.meetingsCalendarNextMonth)
export const trackMeetingsCalendarPrevMonth = () => trackKey(keys.meetingsCalendarPrevMonth)
export const trackMeetingsCalendarOpened = () => trackKey(keys.meetingsCalendarOpened)
export const trackMeetingsCalendarSelectMonth = ({ selectedMonth }: { selectedMonth: string }) =>
  trackEvent(keys.meetingsCalendarSelectMonth, { selectedMonth })
export const trackMeetingsCalendarSelectedDay = () => trackKey(keys.meetingsCalendarSelectedDay)

// Meetings Nav Actions
export const trackMeetingsRaceCodeToggle = ({ raceCode }: { raceCode: string }) =>
  trackEvent(keys.meetingsRaceCodeToggle, { raceCode })
export const trackMeetingsDayQuickSelect = ({ label }: { label: string }) =>
  trackEvent(keys.meetingsDayQuickSelect, { label })
export const trackMeetingsDayPrevArrow = () => trackKey(keys.meetingsDayPrevArrow)
export const trackMeetingsDayNextArrow = () => trackKey(keys.meetingsDayNextArrow)
